import React, { useEffect, useState } from 'react';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Swal from 'sweetalert2'
import _ from 'lodash';
import { cnpj, cpf } from 'cpf-cnpj-validator';
import InputMask from 'react-input-mask';
import { listaUsuarios, deletaUsuario, deletaUsuariosMassa, buscaUsuario, cadastro, buscaUsuarioCpf } from '../../services/mysql'

export default function Convidados() {
    const [usuarios, setUsuarios] = useState([])
    const [selecionados, setSelecionados] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [search, setSearch] = useState("");

    const [valorCpf, setValorCpf] = useState('')
    const [nome, setNome] = useState('')
    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')
    const [confirmaSenha, setConfirmaSenha] = useState('')

    const [convidado, setConvidado] = useState({})
    const [qtdConvidados, setQtdConvidados] = useState(0);

    useEffect(() => {
        carregarUsuarios(currentPage);
    }, [])

    const carregarUsuarios = (page) => {
        mensagemLoading('Buscando Usuarios...')
        const data = {
            perfil: 'PRODUTOR'
        }
        listaUsuarios(data).then((res) => {
            setUsuarios([])
            Swal.close();
            setUsuarios(res);
        });
    };
    const searchUsuario = () => {
        if (!search) {
            mensagemAlerta('Digite o nome do usuário')
            return
        }
        const data = {
            cpf: search.replace(/[^a-z0-9]/gi, ''),
            page: 1
        }
        mensagemLoading('BUscando ...')
        buscaUsuarioCpf(data).then((res) => {
            setConvidado({})
            Swal.close();

            if (res.erro) {
                mensagemAlerta('Nenhum usuário encontrado')
            } else {
                console.log(res)
                setConvidado(res.usuario);
            }
        })
    };

    const toggleSelecionado = (id) => {
        setSelecionados((prev) =>
            prev.includes(id) ? prev.filter((uid) => uid !== id) : [...prev, id]
        );
    };

    const excluirSelecionados = () => {
        Swal.fire({
            title: 'Aviso',
            text: 'Você deseja excluir todos esses usuarios?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Excluir',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                console.log(selecionados)
                mensagemLoading('Realizando exclusão dos usuarios..')
                deletaUsuariosMassa({ ids: selecionados }).then((res) => {
                    if (res.erro) {
                        mensagemErro(res.message)
                    } else {
                        mensagemSucesso(res.message)
                    }
                })
            }
        });
    };

    const adicionarConvidado = (conv) => {
        Swal.fire({
            title: 'Aviso',
            text: `Deseja adicionar ${convidado.nome} como seu convidado? Ao adicionar, você também dará a quantidade de convidados para que ele(a) possa cadastrar`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Excluir',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                console.log(selecionados)
                mensagemLoading('Adicionando aos convidados..')
                // deletaUsuariosMassa({ ids: selecionados }).then((res) => {
                //     if (res.erro) {
                //         mensagemErro(res.message)
                //     } else {
                //         mensagemSucesso(res.message)
                //     }
                // })
            }
        });
    };

    function mensagemLoading(msg) {
        Swal.fire({
            title: 'Aguarde',
            html: msg,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
    }

    function cadastraUsuario() {
        if (!nome) {
            mensagemAlerta('Digite seu Nome')
            return
        }
        if (!cpf.isValid(valorCpf.replace(/[^a-z0-9]/gi, ''))) {
            mensagemAlerta('CPF inválido')
            return
        }
        if (!email) {
            mensagemAlerta('Digite seu Email')
            return
        }
        if (!senha) {
            mensagemAlerta('Digite sua Senha')
            return
        }
        if (!confirmaSenha) {
            mensagemAlerta('Confirme sua senha')
            return
        }
        if (senha !== confirmaSenha) {
            mensagemAlerta('As senhas não iguais')
            return
        }
        mensagemLoading('Buscando cadastrado..')
        const data = {
            nome: nome,
            cpf: valorCpf.replace(/[^a-z0-9]/gi, ''),
            email: email.toLocaleLowerCase(),
            senha: senha,
            perfil: 'PRODUTOR'
        }
        cadastro(data).then((res) => {
            if (res.erro) {
                Swal.close()
                mensagemAlerta(res.message)
            } else {
                mensagemSucesso('Cadastro realizado com sucesso! Realize login com seu email e senha')

            }
        })

    }

    function removeUsuario(item) {
        Swal.fire({
            title: 'Aviso',
            text: 'Deseja remover o usuario ' + item.nome + ' ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                mensagemLoading('Deletando Usuario..')
                deletaUsuario(item.id).then((res) => {
                    console.log(res)
                    if (res.erro) {
                        mensagemErro(res.message)
                    } else {
                        mensagemSucesso('Usuário removido com sucesso')
                    }
                })

            }
        });
    }
    const handleNome = (event) => {
        event.persist();
        setNome(event.target.value);
    }
    const handleCpf = (event) => {
        event.persist();
        setValorCpf(event.target.value);
    }
    const handleEmail = (event) => {
        event.persist();
        setEmail(event.target.value);
    }
    const handleSenha = (event) => {
        event.persist();
        setSenha(event.target.value);
    }
    const handleConfirmaSenha = (event) => {
        event.persist();
        setConfirmaSenha(event.target.value);
    }


    function mensagemErro(msg) {
        Swal.fire('Erro', msg, 'error')
    }
    function mensagemAlerta(msg) {
        Swal.fire('Alerta', msg, 'warning')
    }
    function mensagemSucesso(msg) {
        Swal.fire('Sucesso', msg, 'success').then(() => {
            mensagemLoading('Atualizando Usuários...')
            carregarUsuarios(currentPage);
        })
    }
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Menu />
                <div class="layout-page">
                    <div>
                        <Header />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 " style={{ marginTop: 20 }}>
                                <div className="card">
                                    <div className='row card-body'>
                                        <div className='col-md-4'>
                                            <h5 className="card-header">Novo Convidado</h5>
                                        </div>
                                        <div className='row card-body'>
                                            <div className='col-md-4 '>
                                                <input
                                                    type="text"
                                                    placeholder="Buscar usuário por email"
                                                    className="form-control mb-3"
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                />
                                            </div>
                                            <div className='col-md-2'>
                                                <button onClick={() => searchUsuario()} className="btn btn-primary d-grid " type="submit">Buscar </button>
                                            </div>
                                        </div>
                                        {convidado.id ?
                                            <>
                                                <div className='col-md-12' >
                                                    <p>Nome: {convidado.nome}</p>
                                                    <p>Email: {convidado.email}</p>
                                                </div>
                                                <div className='col-md-2 '>
                                                    <label>Qtd Convidados</label>
                                                    <input
                                                        type="number"
                                                        placeholder="Buscar usuário por email"
                                                        className="form-control mb-3"
                                                        value={qtdConvidados}
                                                        onChange={(e) => setQtdConvidados(e.target.value)}
                                                    />
                                                </div>
                                                <div className='col-md-2' style={{ marginTop: 20 }}>
                                                    <button onClick={() => adicionarConvidado()} className="btn btn-info d-grid " type="submit">Adicionar </button>
                                                </div>
                                            </>
                                            :
                                            null
                                        }
                                        <div className='col-md-12' style={{ marginTop: 25 }}></div>


                                    </div>
                                </div>

                            </div>
                            <div className="container-xxl flex-grow-1 " style={{ marginTop: 20 }}>
                                <div className="card">
                                    <div className='row card-body'>
                                        <div className='col-md-10'>
                                            <h5 className="card-header">Convidados Cadastrados</h5>
                                        </div>
                                        {/* {selecionados.length > 1 ?
                                            <div className='col-md-2' style={{ padding: 10 }}>
                                                <button onClick={() => excluirSelecionados()} className="btn btn-danger d-grid " type="submit">Remover </button>
                                            </div>
                                            :
                                            null
                                        }
                                        <div className='col-md-6 '>
                                            <input
                                                type="text"
                                                placeholder="Buscar usuário..."
                                                className="form-control mb-3"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                            />
                                        </div>

                                        <div className='col-md-2'>
                                            <button onClick={() => searchUsuario()} className="btn btn-primary d-grid " type="submit">Buscar </button>
                                        </div>
                                        <div className='col-md-2'>
                                            <button onClick={() => carregarUsuarios(currentPage)} className="btn btn-info d-grid " type="submit">Todos </button>
                                        </div> */}

                                    </div>
                                    <div className="table-responsive text-nowrap">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) =>
                                                                setSelecionados(
                                                                    e.target.checked
                                                                        ? usuarios
                                                                            .filter((usuario) => usuario.perfil !== "ADMIN")
                                                                            .map((usuario) => usuario.id)
                                                                        : []
                                                                )
                                                            }
                                                            checked={
                                                                selecionados.length > 0 &&
                                                                selecionados.length ===
                                                                usuarios.filter((usuario) => usuario.perfil !== "ADMIN").length
                                                            }
                                                        />
                                                    </th>
                                                    <th>Nome</th>
                                                    <th>CPF</th>
                                                    <th>Email</th>
                                                    <th>Perfil</th>
                                                    <th>Deletar</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-border-bottom-0">
                                                {usuarios.map((usuario) =>
                                                    <tr key={usuario.id}>
                                                        <td>
                                                            {usuario.perfil !== "ADMIN" && (
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selecionados.includes(usuario.id)}
                                                                    onChange={() => toggleSelecionado(usuario.id)}
                                                                />
                                                            )}
                                                        </td>
                                                        <td>{usuario.nome}</td>
                                                        <td>{usuario.cpf}</td>
                                                        <td>{usuario.email}</td>
                                                        <td>{usuario.perfil}</td>
                                                        <td>
                                                            <button onClick={() => usuario.perfil !== 'ADMIN' ? removeUsuario(usuario) : null} type="button" className="btn rounded-pill btn-icon btn-danger">
                                                                <span className="tf-icons bx bx-trash" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                                {usuarios.length === 0 ?
                                                    <p style={{ textAlign: 'center', padding: 10 }} >Sem usuários cadastrados</p>
                                                    :
                                                    null
                                                }

                                            </tbody>
                                        </table>

                                    </div>
                                </div>

                            </div>

                            <Footer />
                            <div className="content-backdrop fade" />
                        </div>
                        {/* Content wrapper */}
                    </div>
                </div>

            </div>
        </div>

    );
}